import React from 'react';

function PlayerCard({ name, role, image }) {
  return (
    <div className="bg-white p-4 rounded-lg shadow-md text-center">
      <img src={image} alt={name} className="w-32 h-32 mx-auto rounded-full" />
      <h3 className="text-lg font-semibold mt-2">{name}</h3>
      <p>{role}</p>
    </div>
  );
}

export default PlayerCard;